
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Alert from 'vux/src/components/alert/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import ChinaAddressV4Data from 'vux/src/datas/china_address_v4.json'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Group from 'vux/src/components/group/index.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import value2name from 'vux/src/filters/value2name.js'
import XAddress from 'vux/src/components/x-address/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
components: {
Group,
XInput,
XHeader,
XButton,
Toast,
Selector,
Grid,
GridItem,
GroupTitle,
Cell,
Alert,
XSwitch,
XAddress
},
name: "expertInfo",
data() {
return {
isReadonly: true,
save_company: '',
expertInfo: {visible: null},
eduList: [
{key: 1, value: "博士研究生"},
{key: 2, value: "硕士研究生"},
{key: 3, value: "本科"},
{key: 4, value: "专科"},
{key: 5, value: "其他"}
],
addressData: ChinaAddressV4Data,
showAddress: false,
address1: [],
address2: "",
result: "",
isShow: false,
strInfo: "",
visiable: 0
};
},
methods: {
modifyInfo() {
if (!this.$refs.input1.valid) {
this.$vux.alert.show({
title: "",
content: "请填写邮箱地址"
});
return
}
if (!this.$refs.input2.valid) {
this.$vux.alert.show({
title: "",
content: "请填写详细地址"
});
return
}
if (!this.$refs.input3.valid) {
this.$vux.alert.show({
title: "",
content: "请填写邮编"
});
return
}
if (!this.$refs.input4.valid || !this.$refs.input5.valid) {
this.$vux.alert.show({
title: "",
content: "请填写紧急联系人信息"
});
return
}
if (!this.$refs.input7.valid || !this.$refs.input8.valid) {
this.$vux.alert.show({
title: "",
content: "请填写现就职公司信息"
});
return
}
if (this.address1.length !== 3 || !this.address2) {
this.$vux.alert.show({
title: "",
content: "请填写通讯地址"
});
return
}
let address = value2name(this.address1, ChinaAddressV4Data);
address = address.split(' ')
if (this.$refs.input1.valid && this.$refs.input2.valid && this.$refs.input3.valid && this.$refs.input4.valid &&
this.$refs.input5.valid && this.$refs.input6.valid && this.$refs.input7.valid && this.$refs.input8.valid) {
if (this.expertInfo.idphoto.origin && this.expertInfo.idphoto2.origin) {
this.expertInfo.province = address[0]
this.expertInfo.city = address[1]
this.expertInfo.district = address[2]
this.expertInfo.daddress = this.address2
delete this.expertInfo.address1
delete this.expertInfo.address2
var userInfo = {...this.expertInfo};
delete userInfo.result;
delete userInfo.advice;
delete userInfo.first;
var app = this;
let opid = localStorage.getItem("userid");
var obj = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
if (!userInfo.visible) {
if (app.save_company && app.save_company !== 'undefined' && app.save_company !== userInfo.company) {
app.$vux.confirm.show({
title: '',
content: '当前已设置为公司不可见本账户，是否开启可见？',
onConfirm: () => {
app.$http.put("/api/v1/experts/" + opid + "/visible", {visible: 'yes'}, obj).then((res) => {
app.updateInfo(opid, userInfo, obj)
}).catch(error => {
if (error.response.data.error_message) {
this.$vux.alert.show({
title: "",
content: JSON.parse(error.response.data.error_message).zh_string
});
}
})
},
onCancel: () => {
app.updateInfo(opid, userInfo, obj)
}
})
} else {
app.updateInfo(opid, userInfo, obj)
}
} else {
if (app.save_company && app.save_company !== 'undefined' && app.save_company !== userInfo.company) {
app.$vux.confirm.show({
title: '',
content: '账户已被' + app.save_company + '绑定，修改后将取消绑定关系',
onConfirm: () => {
app.updateInfo(opid, userInfo, obj)
},
onCancel: () => {
}
})
} else {
app.updateInfo(opid, userInfo, obj)
}
}
} else {
this.$vux.alert.show({
title: "",
content: "请上传身份证信息"
});
}
} else {
this.$refs.input1.focus();
this.$refs.input1.blur();
this.$refs.input2.focus();
this.$refs.input2.blur();
this.$refs.input3.focus();
this.$refs.input3.blur();
this.$refs.input4.focus();
this.$refs.input4.blur();
this.$refs.input5.focus();
this.$refs.input5.blur();
this.$refs.input6.focus();
this.$refs.input6.blur();
this.$refs.input7.focus();
this.$refs.input7.blur();
this.$refs.input8.focus();
this.$refs.input8.blur();
this.$vux.alert.show({
title: "",
content: "输入信息有误"
});
}
},
updateInfo(opid, userInfo, obj) {
if (this.expertInfo.result === 'TO_BE_APPROVE') {
this.updateExpt(opid, userInfo, obj)
} else {
this.$vux.confirm.show({
title: "",
content: "修改信息需要重新进行审核,将会影响接单等功能,确认修改？",
onConfirm: () => {
this.updateExpt(opid, userInfo, obj)
}
})
}
},
updateExpt(opid, userInfo, obj) {
this.$http.put("/api/v1/experts/" + opid, userInfo, obj)
.then((response) => {
this.$router.push({name: "vip"});
this.$vux.loading.hide();
this.$vux.toast.show({
text: "信息修改成功",
type: "success",
time: "1000"
});
})
.catch((error) => {
if (error.response) {
this.$vux.loading.hide();
if (error.response.data.error_message) {
this.$vux.alert.show({
title: "",
content: JSON.parse(error.response.data.error_message).zh_string
});
} else {
this.$vux.alert.show({
title: "",
content: "服务器错误，请稍后重试"
});
}
} else if (error.request) {
this.$vux.loading.hide();
this.$vux.alert.show({
title: "",
content: "服务器错误，请稍后重试"
});
console.log(error.request);
} else {
this.$vux.loading.hide();
this.$vux.alert.show({
title: "",
content: "服务器错误，请稍后重试"
});
console.log("Error", error.message);
}
});
},
updateVisible() {
if (this.expertInfo.first) {
this.expertInfo.first = false
return
}
let opid = localStorage.getItem("userid");
let head = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
this.isShow = true;
let visible = "";
if (this.visiable !== 0) {
this.visiable = 1;
if (this.expertInfo.visible) {
visible = "yes";
this.strInfo = "已设置可见";
} else {
visible = "no";
this.strInfo = "已设置不可见";
}
this.$http.put("/api/v1/experts/" + opid + "/visible", {visible: visible}, head)
.then((res) => {
});
}

}
},
beforeRouteLeave(to, from, next) {
if (to.name === "workExp" || to.name === "idPhoto" || to.name === "eduPhoto" || to.name === "skillPhoto" || to.name === "skill") {
if (this.address1.length !== 3) {
this.expertInfo.address1 = []
} else {
this.expertInfo.address1 = JSON.stringify(this.address1);
}
this.expertInfo.address2 = this.address2
let expertdata = JSON.stringify(this.expertInfo)
localStorage.setItem("expertdata", expertdata)
localStorage.setItem('save_company', this.save_company)
} else {
localStorage.removeItem("expertdata");
localStorage.removeItem('save_company')
}
localStorage.setItem('result', this.expertInfo.result)
next();
},
beforeRouteEnter(to, from, next) {
if (from.name === "workExp" || from.name === "idPhoto" || from.name === "eduPhoto" || from.name === "skillPhoto" || from.name === "skill") {
let expertdata = localStorage.getItem("expertdata");
if (expertdata != null) {
var data = JSON.parse(expertdata);
var result = "";
switch (data.result) {
case "TO_BE_APPROVE":
result = "待审核";
break;
case "APPROVED":
result = "审核通过";
break;
case "REJECTED":
result = "审核未通过";
break;
}
next(vm => {
vm.expertInfo = data;
vm.expertInfo.first = true;
vm.save_company = localStorage.getItem('save_company')
if (data.result !== 'APPROVED') {
vm.isReadonly = false;
}
vm.result = result;
vm.address1 = vm.expertInfo.address1 ? JSON.parse(vm.expertInfo.address1).length === 3 ? JSON.parse(vm.expertInfo.address1) : JSON.parse(vm.expertInfo.address1) : [];
vm.address2 = vm.expertInfo.address2
});
}
} else {
let opid = localStorage.getItem("userid");
var obj = {
headers: {
token: localStorage.getItem("token"),
opid: opid
}
};
if (opid != null) {
var url = "/api/v1/experts/";
AjaxPlugin.$http.get(url + opid, obj)
.then((response) => {
if (response.data.detail) {
var userinfo = {};
userinfo.account = response.data.account;
userinfo.sequence = response.data.sequence;
userinfo.idcard = response.data.detail.idcard;
userinfo.name = response.data.detail.name;
userinfo.mobile = response.data.detail.mobile;
userinfo.email = response.data.detail.email;
userinfo.education = response.data.detail.education;
userinfo.address = response.data.detail.address;

userinfo.zipcode = response.data.detail.zipcode;
userinfo.ename = response.data.detail.ename;
userinfo.emobile = response.data.detail.emobile;
userinfo.etelephone = response.data.detail.etelephone;
userinfo.company = response.data.detail.company;

userinfo.contact = response.data.detail.contact;
userinfo.experience = response.data.detail.experience;
userinfo.speciality = response.data.detail.speciality;
userinfo.idphoto = response.data.detail.idphoto;
userinfo.idphoto2 = response.data.detail.idphoto2;
userinfo.eduphoto = response.data.detail.eduphoto;
userinfo.diploma = response.data.detail.diploma;
userinfo.skillphoto = response.data.detail.skillphoto;
userinfo.result = response.data.detail.result;
userinfo.advice = response.data.detail.advice;
userinfo.memberof = response.data.detail.memberof;
userinfo.visible = response.data.detail.visible;
userinfo.first = response.data.detail.visible;
var result = "";
switch (response.data.detail.result) {
case "TO_BE_APPROVE":
result = "待审核";
break;
case "APPROVED":
result = "审核通过";
break;
case "REJECTED":
result = "审核未通过";
break;
}
localStorage.removeItem("expertdata");
next(vm => {
vm.expertInfo = userinfo;
vm.address1 = [response.data.detail.province, response.data.detail.city, response.data.detail.district]
vm.address2 = response.data.detail.daddress
if (userinfo.result !== 'APPROVED') {
vm.isReadonly = false;
}
vm.result = result;
vm.save_company = response.data.detail.memberof
vm.visiable = response.data.detail.visible
});
}
})
.catch((error) => {
if (error.response) {
console.log(error.response.data);
} else if (error.request) {
console.log(error.request);
} else {
console.log("Error", error.message);
}
});
}
}
}
};



// WEBPACK FOOTER //
// ./src/components/expertInfo.vue